module.exports = __webpack_public_path__ + "static/media/icons-approved.940675d3.svg";